import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";
import type { ShopMemberDto } from "../generated/schema";

export type { ShopMemberDto };

export function useGetShopMembers(shopId: string) {
  return useQuery<ShopMemberDto[]>({
    queryKey: ["get", "shop-members", shopId],
    queryFn: async () => {
      const response = await fetchClient.GET("/shops/{shopId}/members", {
        params: { path: { shopId } },
      });
      return (response.data ?? []) as ShopMemberDto[];
    },
    staleTime: 5 * 60 * 1000,
  });
}
